import React, { useState } from 'react';

import { Button, Dropdown, Form, FormControl, InputGroup, Table } from 'react-bootstrap';

import NewTicketForm from './NewTicketFormComponent';
import search from '../../../assets/svg/search.svg';
import PaginationComponent from '../../../common/components/PaginationComponent';

export interface ticket {
  id: string;
  cat: string;
  title: string;
  openedOn: string;
  updatedOn: string;
  state: string;
  author: string;
}

export interface messages {
  messageid: string;
  ticketid: string;
  content: string;
  openedOn: string;
  intervenantID: string;
  intervenantName?: string;
  files: string[];
}

export const cat = ['Question technique', 'Question tarifaire', 'Question commande', 'Autres'];

const SupportComponent = (_props: any) => {
  const [showForm, setShowForm] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const [searchtitle, setSearchtitle] = useState('');
  const [searchFilter, setSearchFilter] = useState('');

  //A ENLEVER
  const pages = 2;
  const [activePage, setActivePage] = useState(1);
  const pageProps = { pages, setActivePage, activePage };
  //

  const fakeData: ticket[] = [
    {
      id: '001',
      cat: cat[0],
      title: 'Erreur lors du changement de mon nom',
      openedOn: new Date().toDateString(),
      updatedOn: new Date().toDateString(),
      state: 'Traité',
      author: 'John Doe'
    },
    {
      id: '002',
      cat: cat[1],
      title: 'Comment envoyer des données chiffrées',
      openedOn: new Date().toDateString(),
      updatedOn: new Date().toDateString(),
      state: 'En cours',
      author: 'John Doe'
    }
  ];

   
  const [tickets] = useState(fakeData);

  const getData = (): ticket[] => {
    return tickets.filter(
      (element) =>
        element.title.toLowerCase().includes(searchtitle.toLowerCase()) &&
        (searchFilter.length === 0 || element.cat === searchFilter) &&
        (element.state !== 'Traité' || (element.state === 'Traité' && showArchived === true))
    );
  };

  return (
    <div>
      <h1 className="mb-2">Support</h1>
      <div className="partTitle mb-2">Nouveau ticket : </div>
      <div className="d-flex flex-row justify-content-between flex-wrap">
        {showForm ? (
          <Button variant="outline-primary mb-2" onClick={() => setShowForm(false)}>
            <i className="bi bi-x pt-1" style={{ fontSize: '16px' }}></i> Fermer le ticket
          </Button>
        ) : (
          <Button variant="outline-primary mb-2" onClick={() => setShowForm(true)}>
            <i className="bi bi-plus pt-1" style={{ fontSize: '16px' }}></i> Ouvrir un ticket
          </Button>
        )}
        <div className="d-flex flex-row gap-2 mb-2 me-1">
          <InputGroup className="dataGridSearchBar">
            <InputGroup.Text>
              <img src={search} alt="Search Icon" />
            </InputGroup.Text>
            <FormControl
              className="dataGridSearchBarInput"
              placeholder="Rechercher"
              value={searchtitle}
              onChange={(e) => setSearchtitle(e.target.value)}
            />
          </InputGroup>
          <Dropdown>
            <Dropdown.Toggle className="mt-1" variant="outline-primary" id="dropdown-filter">
              <i className="bi bi-filter"></i> Filtrer
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {cat.map((value, _index) => {
                return (
                  <Dropdown.Item
                    key={value}
                    className={value === searchFilter ? '' : 'text-muted'}
                    onClick={() => setSearchFilter(value)}
                  >
                    {value}
                  </Dropdown.Item>
                );
              })}
              <hr className="text-muted" />
              <Dropdown.Item className={searchFilter === '' ? '' : 'text-muted'} onClick={() => setSearchFilter('')}>
                Aucun filtre
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      {showForm && <NewTicketForm />}
      <hr className="text-muted" />
      <div className="partTitle mb-2">Historique de mes tickets support :</div>
      <Form.Check
        type="checkbox"
        label={`Afficher les tickets traités`}
        onChange={(e) => setShowArchived(e.target.checked)}
      />
      <Table borderless responsive className="mt-2 mb-0 datagridTable">
        <thead>
          <tr className="orders-tr">
            <th style={{ width: '16%' }}>Numéro de ticket</th>
            <th style={{ width: '16%' }}>Catégorie</th>
            <th style={{ width: '16%' }}>Sujet</th>
            <th style={{ width: '16%' }}>Date de création</th>
            <th style={{ width: '16%' }}>Date de mise à jour</th>
            <th style={{ width: '16%' }}>Etat</th>
          </tr>
        </thead>
        <tbody>
          {getData().length > 0 ? (
            getData().map((element: ticket, index) => {
              return (
                <tr key={index}>
                  {Object.keys(element).map((key: string | number | symbol, index) =>
                    key === 'author' ? (
                      <React.Fragment key={index}></React.Fragment>
                    ) : (
                      <td key={index}>
                        {index === 0 ? (
                          <a href={'/ticket/' + element[key as keyof ticket]}>{element[key as keyof ticket]}</a>
                        ) : (
                          element[key as keyof ticket]
                        )}
                      </td>
                    )
                  )}
                </tr>
              );
            })
          ) : (
            <></>
          )}
        </tbody>
      </Table>
      {getData().length === 0 ? (
        <p className="mx-auto mt-0 pt-0 text-center bg-white table-empty p-2">Aucun ticket à afficher</p>
      ) : (
        <></>
      )}
      <PaginationComponent {...pageProps} />
    </div>
  );
};

export default SupportComponent;
